// Site access is temporarily gated behind the ComingSoon page until this date.
export const LAUNCH_DATE = new Date("2026-07-20T00:00:00+05:30");

// Temporary early-access window: the app is open until this moment, then
// ComingSoon shows again until LAUNCH_DATE.
export const EARLY_ACCESS_END = new Date("2026-07-16T12:00:00+05:30");
